import React, { useState } from 'react';
import { LeadActionInput, MyCompanyType } from 'types';
import AMCompanyCardMoreOptions from './AMCompanyCardMoreOptions';
import AMCompanyCardFooter from './AMCompanyCardFooter';
import AMCompanyCardTitle from './AMCompanyCardTitle';
import { useNavigate } from 'react-router-dom';
import { useRecommendationsContext } from 'src/context/RecommendationsProvider';
import { Drawer } from '../shared/Drawer';
import { useMediaQuery } from '@mui/material';
import AMQualifyDisQualifyLead from '../recruiterPositions/AMQualifyDisQualifyLead';
import { useMutation, useQueryClient } from 'react-query';
import { takeActionOnLead } from 'src/apis/company';
import { useToast } from 'src/context/ToastProvider';
import { get } from 'lodash';
import AMAssignBDPOC from '../recruiterPositions/AMAssignBDPOC';

interface Props {
	isActive?: boolean;
	onClick?: () => void;
	companyObj: MyCompanyType;
	handleViewCompanyDetails: (comp: MyCompanyType['company']) => void;
	bdPOCName?: string;
	bdPOCId?: string;
	leadGen?: any;
}

const AMCompanyCard = ({ isActive, companyObj, handleViewCompanyDetails, onClick, bdPOCName, bdPOCId }: Props) => {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const toast = useToast();

	const isMobile = useMediaQuery('(max-width:960px)');
	const { setSelectedCompany, setFilterApplied } = useRecommendationsContext();

	const [openAssignBdPOcDrawer, setOpenAssignBDPOCDrawer] = useState<boolean>(false);
	const [openLeadDrawer, setIsOpenLeadDrawer] = useState<boolean>(false);
	const isLead = companyObj.company.isLead;

	const handleEditCompany = (companyId: string) => {
		navigate(`/edit-company/${companyId}`);
	};

	const leadActionFn = useMutation(['takeActionOnLead'], takeActionOnLead, {
		onSuccess() {
			queryClient.refetchQueries(['getMyCompaniesQuery']);
			toast({
				title: 'Action executed successfully',
				type: 'success',
			});
			setIsOpenLeadDrawer(false);
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				title: `Error occured ${errorMessage}`,
				type: 'error',
			});
		},
	});

	return (
		<div className="relative">
			<button
				className="w-full rounded-[12px] dark:bg-[#1F2A37] bg-white border border-solid border-[#C7C9D9] dark:border-[#c7c9d91a] relative h-full hover:cursor-pointer shadow-sm transition-all hover:shadow-up active:scale-[0.98] focus-visible:shadow-up focus-visible:ring-2 focus-visible:outline-none "
				onClick={() => {
					setFilterApplied(false);
					setSelectedCompany(companyObj);
					if (onClick) {
						onClick();
					} else if (!isLead) {
						navigate(`/my-positions/${companyObj.company._id}`);
					}
				}}
			>
				<div className="p-3 pb-0 grow-2">
					<AMCompanyCardTitle
						isActive={isActive}
						isBlacklisted={companyObj?.company?.isBlacklisted}
						activePositions={companyObj.activePositions}
						companyData={companyObj}
					/>
				</div>

				<AMCompanyCardFooter
					company={companyObj}
					handleViewCompanyDetails={handleViewCompanyDetails}
					// onLeadAction={(val: LeadActionInput) => leadActionFn.mutate(val)}
					onLeadAction={() => setOpenAssignBDPOCDrawer(true)}
					openLeadActionDrawer={() => setIsOpenLeadDrawer(true)}
					isLoading={leadActionFn.isLoading}
				/>
			</button>
			<AMCompanyCardMoreOptions
				company={companyObj.company}
				handleEditCompany={handleEditCompany}
				handleViewCompany={handleViewCompanyDetails}
				customStyleClass="absolute top-4 right-4"
			/>

			<Drawer
				maxHeight="90dvh"
				minHeight="max-content"
				boxShadow="0px -8px 32px 0px #00000040"
				isOpen={openLeadDrawer}
				isModal={!isMobile}
				onClose={() => {
					setIsOpenLeadDrawer(false);
				}}
				header={
					<h1 className="text-[#1C1C28] dark:text-inherit text-lg font-inter font-[500] px-5 pt-4">
						{companyObj.company.name} - Status
					</h1>
				}
				body={
					<AMQualifyDisQualifyLead
						companyId={companyObj.company._id}
						isLoading={leadActionFn.isLoading}
						onSubmit={(val: LeadActionInput) => leadActionFn.mutate(val)}
					/>
				}
			/>
			<Drawer
				maxHeight="90dvh"
				minHeight="max-content"
				boxShadow="0px -8px 32px 0px #00000040"
				isOpen={openAssignBdPOcDrawer}
				isModal={!isMobile}
				onClose={() => {
					setOpenAssignBDPOCDrawer(false);
				}}
				header={
					<h1 className="text-[#1C1C28] dark:text-inherit text-lg font-inter font-[500] px-5 pt-4">
						{companyObj.company.name} - Status
					</h1>
				}
				body={
					<AMAssignBDPOC
						bdPOCName={bdPOCName}
						bdPOCId={bdPOCId}
						companyId={companyObj.company._id}
						isLoading={leadActionFn.isLoading}
						onSubmit={(val: LeadActionInput) => leadActionFn.mutate(val)}
						leadGen={companyObj?.company?.leadGenMeta}
					/>
				}
			/>
		</div>
	);
};

export default AMCompanyCard;
